import { writable } from 'svelte/store'

// definitionState is used to keep track of which accordions are open/closed in the FloodCategories component.
export const definitionState = writable({
  Major: false,
  Moderate: false,
  Minor: false,
  Action: false,
  Low: false,
  Record: false,
})

export const isInView = writable({})
export const nwmLoaded = writable(false)
export const refresh = writable(false)
